import { useEffect, useState } from 'react';
import { Popover } from '@meitu/saas-ui';
import { useFramework } from '@/framework';
import { Hierarchy } from '../../hierarchy';
import type { IStageToolbarItemRenderArgs } from '../../types';
import { HierarchyActionBridge } from './action-bridge';

type Props = IStageToolbarItemRenderArgs & {
    available: boolean;
    hideWhenAgentLayoutEnabled?: boolean;
};

export const PopoverHierarchyItem = ({ active, available, hideWhenAgentLayoutEnabled, setActive, toolbar }: Props) => {
    const framework = useFramework();
    const [agentLayoutEnabled, setAgentLayoutEnabled] = useState(() => framework.service.agentLayout.getEnable());

    useEffect(() => {
        const listener = framework.service.agentLayout.onEnableChange((enabled: boolean) => {
            setAgentLayoutEnabled(enabled);
            // 隐藏入口时同步关闭受控 Popover，避免留下没有触发器的悬浮层。
            if (enabled && hideWhenAgentLayoutEnabled) setActive(false);
        });
        return () => framework.service.events.off(listener);
    }, [framework, hideWhenAgentLayoutEnabled, setActive]);

    if (hideWhenAgentLayoutEnabled && agentLayoutEnabled) return null;

    return (
        <>
            <HierarchyActionBridge toolbar={toolbar} />
            <Popover
                open={active}
                showArrow={false}
                // Popover 负责定位，因此 Panel 以 embedded 形态渲染，不再创建独立拖动宿主。
                content={<Hierarchy.Panel embedded onClose={() => setActive(false)} />}
                zIndex={9999}
                placement="top"
                overlayClassName="stage-toolbar-hierarchy-popover"
                align={{ offset: [90, -20] }}
            >
                <Hierarchy.Trigger open={active} disabled={!available} disableWhenEmpty onOpenChange={setActive} />
            </Popover>
        </>
    );
};
